import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/dc-join.png'
import _imports_1 from '@/assets/yt-sub.png'


const _withScopeId = n => (_pushScopeId("data-v-02ffa22a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "banner container",
  ref: "target"
}
const _hoisted_2 = { class: "top-cont" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://discord.com/invite/2CuqQ9HNu4",
  target: "__blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Join image"
  })
], -1))
const _hoisted_5 = { class: "top-cont" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.youtube.com/@Jortsoft",
  target: "__blank"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Join image"
  })
], -1))

import { store } from '@/store/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'Banner',
  setup(__props) {

const Store = store()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? "გაწევრიანდი Discord სერვერზე!" : "Join Discord server!"), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(Store).getCurrentLang == "GE" ? "გამოიწერე YouTube არხი!" : "Subscribe YouTube channel!"), 1),
      _hoisted_7
    ])
  ], 512))
}
}

})